import { render, staticRenderFns } from "./Yfstmh.vue?vue&type=template&id=faacb8e2&scoped=true"
import script from "./Yfstmh.vue?vue&type=script&lang=js"
export * from "./Yfstmh.vue?vue&type=script&lang=js"
import style0 from "./Yfstmh.vue?vue&type=style&index=0&id=faacb8e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faacb8e2",
  null
  
)

export default component.exports